import { useState } from "react";
import { ToggleMobMenu } from "../ToggleMobMenu/ToggleMobMenu";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../store/hooks";
import { IBurgerMenu } from "../../interfaces/BurgerMenuInterface";
import { HeaderMenuI } from "../../interfaces/HeaderInterface";
import {
  BurgerContainer,
  LangAndBtn,
  ToggleContainer,
} from "./BurgerMenuStyles";
import { LangMenu } from "../Header/HeaderStyles";
import { NavLink } from "react-router-dom";
import { generateLink } from "../../functions/routingFuntion";

export const BurgerMenu = ({
  showMenu,
  closeNav,
  titles,
  changeLanguage,
}: IBurgerMenu) => {
  const [openIndex, setOpenIndex] = useState<null | number>(null);
  const language = useAppSelector((state) => state.locale.localStorageValue);
  const { t } = useTranslation();

  const toggleMenu = (index: number | null) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <BurgerContainer id="myNav" showMenu={showMenu}>
      <ToggleContainer>
        {titles.map((title: HeaderMenuI, index: number) => {
          return (
            <div key={title.title}>
              <ToggleMobMenu
                index={index}
                openIndex={openIndex}
                toggleMenu={toggleMenu}
                title={title}
                closeNav={closeNav}
              />
            </div>
          );
        })}
      </ToggleContainer>
      <LangAndBtn>
        <LangMenu
          name="lang"
          id="1"
          onChange={changeLanguage}
          value={language}
          className="mob__lang__menu "
        >
          <option value="en">EN</option>
          <option value="de">DE</option>
          <option value="fr">FR</option>
        </LangMenu>
        <NavLink
          to={generateLink("/auth/login", language)}
          onClick={closeNav}
          className="header__buttons"
        >
          {t("header.logIn")}
        </NavLink>
      </LangAndBtn>
    </BurgerContainer>
  );
};
